import { useMemo } from 'react';

import { useLocation } from 'js/lib/useRouter';

import useIsOnLocaleSubfolderRoute from 'bundles/internationalization-lib/hooks/useIsOnLocaleSubfolderRoute';
import getFiltersList from 'bundles/search-common/components/filters/getFiltersList';
import useFilterListOrder from 'bundles/search-common/components/filters/useFilterListOrder';
import { DEFAULT_SEARCH_FILTERS_SORTED_BY_USAGE } from 'bundles/search-common/constants/filter';
import { useShowCourseraTier } from 'bundles/search-common/providers/LearnerProvider';
import { shouldShowFreeQueryPageConfigPreview } from 'bundles/search-common/utils/pageConfigUtils';

const useSearchFilterConfigs = (filtersOrder?: string[]) => {
  const shouldShowCourseraPlusFilter = useShowCourseraTier();
  const filtersListOrder = useFilterListOrder(filtersOrder ?? DEFAULT_SEARCH_FILTERS_SORTED_BY_USAGE);
  const shouldHideSkillsFilter = useIsOnLocaleSubfolderRoute();
  const query = useLocation().query.query;
  const shouldShowCostFilter = shouldShowFreeQueryPageConfigPreview(query);
  return useMemo(
    () => ({
      filterGroupConfigs: getFiltersList({
        shouldShowCourseraPlusFilter,
        filtersListOrder,
        shouldHideSkillsFilter,
        shouldShowCostFilter,
      }),
      filtersListOrder,
    }),
    [shouldShowCourseraPlusFilter, shouldHideSkillsFilter, filtersListOrder, shouldShowCostFilter]
  );
};

export default useSearchFilterConfigs;
